import { useState, useEffect } from 'react';
import { Modal, Input } from 'antd';

function NewsModal({ open, onCancel, onSubmit, currentNews }) {
    const [formData, setFormData] = useState({
        message: ""
    });
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (currentNews) {
            setFormData({ message: currentNews.message });
        } else {
            setFormData({ message: "" });
        }
    }, [currentNews, open]);

    const handleSubmit = () => {
        setLoading(true)
        if (formData.message.trim()) {
            onSubmit(formData);
            setLoading(false)
        } else {
            setLoading(false)
            alert('Message is required');
        }
    };

    return (
        <Modal
            className='password-model relative top-1 lg:top-7 lg:!w-[34vw]'
            footer={[
                <div key="footer" className='col-span-12 gap-2 flex flex-shrink-0 flex-wrap items-center justify-end p-[1rem] border-t-[1px] border-t-[#dee2e6]'>
                    <button
                        type="button"
                        className="m-[5px] text-[#fff] bg-[#0d6efd] border-[#0d6efd] font-bold !px-[10px] !py-[5px] !text-[.875rem] bg-[linear-gradient(#022c43,_#18b0c8)] rounded-[.375rem]"
                        disabled={loading}
                        onClick={handleSubmit}
                    >
                        {currentNews ? 'Update' : 'Add'}
                    </button>
                    <button
                        type="button"
                        className="bg-[linear-gradient(-180deg,_#b8beca_0%,_#989595_100%)] font-bold !px-[10px] !py-[5px] !text-[.875rem] m-[5px] text-[#212529] text-center no-underline align-middle border-[1px] border-[solid] border-[transparent] rounded-[.375rem]"
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                </div>
            ]}
            onCancel={onCancel}
            open={open}
        >
            <div className='grid grid-cols-12'>
                <div className='col-span-12 px-[6px] py-[5px] font-bold text-[0.875rem] rounded-t-[5px] h-[35px] bg-[linear-gradient(#022c43,_#18b0c8)] text-[#ffffff] flex flex-shrink-0 items-center justify-between'>
                    <h5 className='text-[0.938rem] font-bold mb-0 leading-normal'>
                        {currentNews ? 'Update News Message' : 'Add News Message'}
                    </h5>
                    <button type="button" onClick={onCancel}>
                        <span className='text-[1.3125rem] font-bold'>×</span>
                    </button>
                </div>
                <div className='col-span-12 !bg-[#ffffff] !text-[#23282c] relative flex-auto p-4'>
                    <div className='grid grid-cols-12 lg:gap-x-6'>
                        <div className='col-span-12 '>
                            <div className='mb-4 !text-[#23282c]'>
                                <label className='inline-block mb-[.5rem] !text-[#23282c]' htmlFor="message">
                                    Message
                                </label>
                                <div className='relative flex flex-wrap items-stretch w-full text-[#23282c]'>
                                    <Input
                                        id='message'
                                        name='message'
                                        required
                                        onChange={(e) => setFormData({ message: e.target.value })}
                                        value={formData.message}
                                        className='antd-password'
                                        placeholder="Message.."
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default NewsModal;